import React from 'react';
import st from './divider.module.scss';

export const Divider = ({className = '', stClassName}: {className?: string; stClassName?: string}) => {
  return <div className={`${st.divider} ${st[className]} ${stClassName}`} />;
};
